import { BOOK_DELIMITER_TYPES } from '../../constants';

/**
 * @method sortByIndexOfType
 * @param {Array} array - array to be sorted
 * @param {String} useIndexOfType - type whose index is to be used to sort items
 * @returns {Array} sorted Array
 */
const sortByIndexOfType = (array, useIndexOfType) => {
  if (!useIndexOfType || !BOOK_DELIMITER_TYPES.includes(useIndexOfType)) {
    console.warn(
      `${useIndexOfType} cannot be used to sort array. Use either 'page', 'document', 'marker' or 'topLevelMarker'.`,
    );
    return array;
  }

  if (!array.length) {
    return array;
  }

  return array.sort((a, b) => {
    const aIndex = a[useIndexOfType]?.index;
    const bIndex = b[useIndexOfType]?.index;

    if (aIndex === undefined || aIndex === null) {
      if (bIndex === undefined || bIndex === null) {
        return 0; // both are undefined or null
      } else {
        return 1; // put a after b in the array
      }
    }

    if (bIndex === undefined || bIndex === null) {
      return -1; // put b after a in the array
    }

    return aIndex - bIndex;
  });
};

export default sortByIndexOfType;
